export const fiscalBoard = {
	selectMonth: "Selecione um mês",
	addPlace: "Adicionar local",
	selectPlace: "Selecione um local",
	nfceIssued: "NFC-e emitidas",
	nfseIssued: "NFS-e emitidas",
	nfce: "NFC-e",
	nfse: "NFS-e",
	fiscalProfile: "Emissão por perfil fiscal",
	column: {
		date: "Data",
		errorType: "Tipo de erro",
		type: "Tipo",
		value: "Valor",
		total: "Total Emissível",
	},
	issuingErrors: "Erros de emissão",
};
